import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';
import { useTkv2HandleIconClick } from './useTkv2HandleIconClick.ts';

export const AlertsItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'craftsman-alerts' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="alerts"
      label="Alerts"
      icon="alarm-warning"
      isSelected={isSelected}
      onClick={() => handleIconClick('craftsman-alerts')}
    />
  );
};
